import { createContext, useContext, useState } from "react";

const PageTitleContext = createContext({
  pageTitle: "",
  setPageTitle: () => {},
});

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("");

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => useContext(PageTitleContext);
